import { render } from "./SectionSystemDetails.vue?vue&type=template&id=14281e11&scoped=true"
const script = {}

import "./SectionSystemDetails.vue?vue&type=style&index=0&id=14281e11&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14281e11"]])

export default __exports__